module.exports = __webpack_public_path__ + "img/13.4e7f70b5.jpg";